// extracted by mini-css-extract-plugin
export default {"multiSelect":"formStyles_multiSelect__9k7WP"};